module.exports = __webpack_public_path__ + "static/logo_black_green_white.5cd9a13f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo_black_green_white.png
// module id = 562
// module chunks = 114276838955818